import React from 'react';
import './HeadAndSub.css';

const HeadAndSub = (props) => {

    // const classList = props.SubTitle === "Free Trial" ? ["SubTitle", "FreeTrialStatus"] : ["SubTitle"] && props.SubTitle === "Challenge" ? ["SubTitle", "ChallengeSTatus"] :  ["SubTitle"]  && props.SubTitle === "Varification" ? ["SubTitle", "VarificationSTatus"] : [`SubTitle ${props.SubTitleClass}`]
    return (
        <>
            <div  className={props.HeadAndSubClassName}>
                <p className={`HeadTitle mbb-5 ${props.HeadTitleClass}`}>{props.HeadTitle}</p>
                <p className={`SubTitle ${props.SubTitleClass}`}>{props.SubTitle}</p>
            </div>
        </>
    );
}
export default HeadAndSub;